import { useNavigate } from "react-router-dom";

const FindIdPage = () => {
    // const [method, setMethod] = useState("email");
    const navigate = useNavigate(); // 페이지 이동을 위한 hook

    // const handleFindClick = () => {
    //     if (method === "email") {
    //         navigate("/find-id/email"); // 이메일 페이지로 이동
    //     } else {
    //         navigate("/find-id/phone"); // 휴대전화 페이지로 이동
    //     }
    // };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-white px-4 mt-[130px]">
            <div className="w-full max-w-md bg-white rounded-lg p-8">
                <h2 className="text-2xl font-bold mb-12 text-center font-family-pretendard semi-bold">
                    아이디 찾는 방법 선택
                </h2>
                <div className="flex justify-center space-x-4 mb-6">
                    <button
                        onClick={() => navigate("/find-id/email")}
                        style={{ transition: 'transform 0.2s ease, background-color 0.2s ease' }}
                        className={`flex items-center px-4 py-2 bg-gray-200 text-gray-600
                            hover:bg-blue-500 hover:text-white hover:bg-blue-600 hover:scale-105 
                            rounded-lg w-full h-[220px] justify-center 
                        } active:scale-95`}
                    >
                        {/* <Mail className="mr-2" size={24} />
                        이메일로 인증하기 */}
                        <div className="flex flex-col items-center">
                            <img
                                src="/images/icon/find_by_email.png"
                                alt="email"
                            />
                            <br />
                            <h3 className="font-family-pretendard semi-bold">이메일로 인증하기</h3>
                        </div>
                    </button>
                    <button
                        onClick={() => navigate("/find-id/phone")}
                        style={{ transition: 'transform 0.2s ease, background-color 0.2s ease' }}
                        className={`flex items-center px-4 py-2 bg-gray-200 text-gray-600
                            hover:bg-blue-500 hover:text-white hover:bg-blue-600 hover:scale-105 
                            rounded-lg w-full h-[220px] justify-center 
                        } active:scale-95`}
                    >   
                        {/* <Smartphone className="mr-2" size={24} />
                        휴대전화로 인증하기 */}
                        
                        <div className="flex flex-col items-center mt-2">
                            <img
                                src="/images/icon/find_by_phone.png"
                                alt="phone"
                            />
                            <br />
                            <h3 className="font-family-pretendard semi-bold">휴대전화로 인증하기</h3>
                        </div>
                        
                    </button>
                </div>
                <div className="text-center mb-6">
                    <button
                        onClick={() => navigate("/find-pw")}
                        style={{ color: '#727B8B' }}
                        className="text-blue-500 underline decoration-2 underline-offset-4 font-family-pretendard semi-bold"
                    >
                        비밀번호 찾기
                    </button>
                </div>
            </div>

            <div className="flex justify-center mt-[150px]">
                <img
                    src="/images/softcat_new_logo.png"
                    alt=" "
                    className="w-[180px] h-[50px]"
                />
            </div>
        </div>
    );
};

export default FindIdPage;
